import { ServiceItemCard } from "./ServiceItemCard";
import { hasRichContent } from "../utils/richText";

const isRichItem = (item) =>
  typeof item === "object" && item !== null && (hasRichContent(item.description) || (item.images?.length ?? 0) > 0);

export const Service = ({ data, no }) => {
  const isAlt = no % 2 === 0;
  const items = data.items ? [...data.items].sort((a, b) => (isRichItem(b) ? 1 : 0) - (isRichItem(a) ? 1 : 0)) : [];

  return (
    <section
      id={`service-${no}`}
      className={`service-section ${isAlt ? "service-section--alt" : ""}`}
    >
      <div className="container">
        <div className="section-title service-title">
          <h2>
            {data.title} <span className="service-no"></span>
          </h2>
          {data.text ? <p>{data.text}</p> : null}
        </div>

        <div className="service-grid">
          {items.map((item, i) => (
            <ServiceItemCard key={i} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
};
